import React from "react";
import { PiDropFill } from "react-icons/pi";
import "./Droplets.css";
import { useNavigate } from "react-router-dom";
import { haptic } from "@/lib/haptic";
import { useWaterDroplets } from "@/hooks/useWaterDroplets";

const formatNumber = (num: number) => {
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "k";
  }
  return num.toString();
};

const Droplets: React.FC<{ pulse: boolean }> = ({ pulse }) => {
  const nav = useNavigate();
  const { dropletsCount } = useWaterDroplets();

  const handleClick = () => {
    haptic.soft();
    nav("/home/grow");
  };

  return (
    <div
      onClick={handleClick}
      className={`h-6 justify-start items-center inline-flex shadow-sm bg-[var(--color-blue)] rounded-lg p-[4px] gap-1 ${
        pulse ? "drops-animation animate-bounce" : ""
      }`}
    >
      <PiDropFill className="w-3 h-3 text-white" />
      <div className="text-center text-white text-sm font-semibold">
        {formatNumber(dropletsCount)}
      </div>
      {pulse && (
        <>
          <div className="blob-3"></div>
        </>
      )}
    </div>
  );
};

export default Droplets;
